import { render, staticRenderFns } from "./DynamicFieldset.vue?vue&type=template&id=0381d26c&scoped=true&"
import script from "./DynamicFieldset.vue?vue&type=script&lang=js&"
export * from "./DynamicFieldset.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFieldset.vue?vue&type=style&index=0&id=0381d26c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0381d26c",
  null
  
)

export default component.exports